import React, { useEffect, useRef } from "react"; // <-- Adicionado o useRef aqui
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from ".././Loading";
import { useAuth } from "../../hooks/useAuth";
import { TokenController } from "../../../mtlogin-api/controllers/TokenController"; 
import { UserController } from "../../../mtlogin-api/controllers/MTLoginUserController";

export const LoginCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login, logout } = useAuth(); // Trazemos as ações do seu AuthProvider

    // 1. Criamos a trava para evitar a dupla execução do React 18
    const inicializado = useRef(false);

    useEffect(() => {
        // 2. Se já estiver processando, aborta a segunda chamada invisível do React
        if (inicializado.current) return;

        const processarRetorno = async () => {
            // 1. Pega o código que o governo devolveu na URL
            const code = searchParams.get("code");
            
            // 2. Pega a chave que você guardou na Ida
            const verifier = sessionStorage.getItem("pkce_code_verifier") || undefined;

            if (code) {
                // 3. Trava o componente! A partir daqui, ele não faz mais a mesma requisição
                inicializado.current = true;

                try {
                    console.log("Iniciando troca do código pelo Token...");
                    
                    // 3. Chama o Controller passando o code e a chave PKCE
                    const sessionController = new TokenController(code, verifier);
                    const hasToken = await sessionController.hasToken();

                    if (hasToken) {
                        // 4. Pega as informações do usuário (Token decodificado e registro)
                        const userController = new UserController();
                        const sessionData = await userController.getUserInformation();

                        if (sessionData.loggedIn) {
                            // 5. Salva no contexto global do React (AuthProvider)
                            login(sessionData.loggedIn, sessionData.registered);
                            
                            // Limpa a chave do storage por segurança, já que não precisamos mais dela
                            sessionStorage.removeItem("pkce_code_verifier");

                            // 6. Redireciona para o sistema
                            navigate("/home");
                        } else {
                            console.error("Usuário não encontrado na sessão.");
                            logout();
                            navigate("/logininitiator");
                        }
                    } else {
                        console.error("Falha ao obter o Token.");
                        logout();
                        navigate("/logininitiator");
                    }
                } catch (error) {
                    console.error("Falha ao validar login", error);
                    logout();
                    navigate("/serviceunavailable"); 
                }
            } else {
                console.error("Faltando code na URL");
                navigate("/logininitiator"); 
            }
        };

        processarRetorno();
    }, [searchParams, navigate, login, logout]);

    return <Loading />;
};